import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useProjectAttachmentsQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project", project.id, "attachments"],
        queryFn: async () => {
            const response = await apiClient.getProjectAttachments({
                params: { projectId: project.id },
            });
            if (response.status !== 200) {
                throw new Error("Failed to fetch attachments");
            }
            return response.body.data;
        },
    });
}
